<template>
  <rp-overlay :active="!!getShowOverlay">
    <rp-alert
      v-if="getShowOverlay === 'error'"
      class="error-icon"
      icon="warning_rounded"
      :message="getOverlayMessage ? getOverlayMessage : 'Error'"
      :onClick="executeCommand" />

    <rp-alert
      v-else-if="getShowOverlay === 'success'"
      icon="done"
      :message="getOverlayMessage ? getOverlayMessage : 'Success'"
      :onClick="executeCommand" />
  </rp-overlay>
</template>

<script>
import Overlay from 'raypro_ui/src/components/ui/Overlay'
import Alert from 'raypro_ui/src/components/ui/Alert'
import * as httpErrors from 'raypro_ui/src/store/modules/httpRequests/types'
import {mapGetters, mapMutations} from 'vuex'

export default {
  components: {
    'rp-overlay': Overlay,
    'rp-alert': Alert
  },

  computed: {...mapGetters(['getShowOverlay', 'getOverlayMessage', 'getOverlayFunction'])},

  methods: {
    ...mapMutations([httpErrors.SERVER_SHOW_OVERLAY, httpErrors.SERVER_OVERLAY_FUNCTION, httpErrors.SERVER_OVERLAY_MESSAGE]),

    executeCommand() {
      if(this.getOverlayFunction) { this.getOverlayFunction() }

      this.onClose()
    },

    onClose() {
      this[httpErrors.SERVER_SHOW_OVERLAY](null)
      this[httpErrors.SERVER_OVERLAY_FUNCTION](null)
      this[httpErrors.SERVER_OVERLAY_MESSAGE](null)
    }
  }
}
</script>

<style lang="sass">
@import 'raypro_ui/src/styles/base/_variables.sass'
@import 'raypro_ui/src/styles/helpers/_mixins.sass'

.error-icon
  .sprite
    fill: $color-error!important

.server-error-modal
  padding-top: 1rem
  position: relative
  padding: 30px

  h2
    display: flex
    align-items: center
    padding-bottom: 30px

    .sprite
      margin-right: 2rem

      svg
        fill: $color-error

    span
      font-size: 1.8rem
      font-weight: $font-medium

  .actions
    display: flex
    justify-content: space-between
    align-items: center
</style>



// WEBPACK FOOTER //
// src/components/ServerError.vue